<template>
    <div class="main">Hello world!</div>
</template>

<script>
export default {
    name: "default"
}
</script>

<style lang="scss" scoped>

</style>